import { createReducer, on } from "@ngrx/store";
import { EdicaoOutputDto } from "src/app/domain/DTOs/output/jornal/edicao-output.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterUltimaEdicao, obterUltimaEdicaoSuccess, obterUltimaEdicaoFailure, obterUltimaEdicaoFinish } from "../../actions/Jornal/obter-ultima-edicao.action";

export interface ObterUltimaEdicaoState {
    response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterUltimaEdicaoState = {
    response: null,
    error: null,
};

export const ObterUltimaEdicaoReducer = createReducer(
    initialState,
    on(obterUltimaEdicao, state => ({ ...state, error: null })),
    on(obterUltimaEdicaoSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterUltimaEdicaoFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterUltimaEdicaoFinish, state => ({ ...state, response: null, error: null }))
);
